"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cellStyle = {
  border: 'none'
};

function HeaderRange(props) {
  var content = props.content;
  return _react.default.createElement(_semanticUiReact.Table.Row, null, _react.default.createElement(_semanticUiReact.Table.HeaderCell, {
    style: cellStyle,
    colSpan: "7"
  }, content));
}

HeaderRange.handledProps = ["content"];
HeaderRange.propTypes = {
  /** Selected dates range. */
  content: _propTypes.default.string.isRequired
};
var _default = HeaderRange;
exports.default = _default;